import FilterBadges from './filterBadges';
import BadgeItemView from './filterBadge';

export default FilterBadges.extend({
  itemView: BadgeItemView,

  tagName: 'tr',

  initialize(...args) {
    FilterBadges.prototype.initialize.apply(this, args);

    this.collection = this.columns;
    this.listenTo(this.filters, 'change reset add remove refresh', this.render);
  },

  hasFilters() {
    return !this.filters.isEmpty();
  },

  onRender() {
    this.toggleBadges();
  },

  toggleBadges() {
    this.$el.toggleClass('hidden', !this.hasFilters());
  }
});
